<template>
  <div class="h5-order-item-wrap">
    <div class="order-top">
      <p class="order-no">交易单号：{{ orderInfo.order_no }}</p>
      <!-- 状态 -->
      <div v-if="signUpSuccess" class="order-status-success">
        <span>报名完成</span>
      </div>
      <div v-else class="order-status">
        <span class="countdown-wrap" v-if="orderInfo.state === 1"
          >待支付&nbsp;
          <CountDown
            class="countdown"
            :callback="callback"
            v-if="orderInfo.sub_order_list && orderInfo.sub_order_list.length"
            :type="2"
            :endTime="orderInfo.sub_order_list[0].timeout_at"
            endText=""
        /></span>
        <span v-else-if="handleFailTips">{{ handleFailTips }}</span>
        <span v-else-if="orderInfo.group_state === 1">待成团</span>
      </div>
    </div>
    <div
      class="order-list"
      v-if="orderInfo.sub_order_list && orderInfo.sub_order_list.length"
    >
      <div
        v-for="item in orderInfo.sub_order_list.slice(0, length)"
        :key="item.goods_id + item.order_no"
        class="course-item"
      >
        <div @click="jumpProductDetail(item.course_id)" class="course-wrap">
          <img
            class="cover"
            :src="handleImageUrl(item.goods_cover_url) + '?imageView2/0/w/340'"
            alt=""
          />
          <div class="course-info">
            <p class="title">
              {{ item.goods_title }}
            </p>
            <!-- 单个课-操作 -->
            <template v-if="signUpSuccess">
              <button
                v-if="orderInfo.activity_type === 4 && orderInfo.activity_id"
                @click="goGroupInfo"
                class="primary-btn btns-wrap"
              >
                拼团详情
              </button>
            </template>
          </div>
        </div>
      </div>
      <button
        v-if="!showMore && showMoreBtn"
        class="more-btn"
        @click="showMoreCourse"
      >
        查看更多<i class="el-icon-arrow-down"></i>
      </button>
      <button
        v-else-if="showMoreBtn && showMore"
        @click="closeMoreCourse"
        class="more-btn"
      >
        收起<i class="el-icon-arrow-up"></i>
      </button>
    </div>
    <div class="order-bottom">
      <div class="operate-wrap">
        <button
          v-if="signUpSuccess && orderInfo.is_past_refund_time"
          @click="refund(orderInfo)"
          class="primary-btn cancel-btn"
        >
          申请退款
        </button>
        <button
          v-if="showInputAddressBtn"
          @click="inputAddress(orderInfo)"
          class="primary-btn"
        >
          填写地址
        </button>
        <button
          v-if="showViewAddressBtn"
          @click="inputAddress(orderInfo)"
          class="cancel-btn"
        >
          地址信息
        </button>
        <template v-if="!signUpSuccess">
          <button
            v-if="
              orderInfo.activity_type === 4 &&
              orderInfo.group_state === 1 &&
              orderInfo.state === 2 &&
              orderInfo.reply_result === 0 &&
              !handleFailTips
            "
            @click="groupRefund"
            class="cancel-btn"
          >
            取消拼团
          </button>
          <button
            v-else-if="orderInfo.state === 1"
            @click="handleCancelOrder"
            class="cancel-btn"
          >
            取消订单
          </button>
          <template v-if="handleFailTips || showGroupInfoBtn">
            <button
              @click="goGroupInfo"
              v-if="showGroupInfoBtn"
              class="primary-btn"
            >
              拼团详情
            </button>
          </template>
        </template>
      </div>
      <div class="total-price-wrap">
        <p class="total-price">
          <span>{{ signUpSuccess ? "实付" : "应付" }}金额：</span
          >{{ formatPrice(orderInfo.real_price) }}
          <span v-if="signUpSuccess" class="channel">
            ({{ payType[orderInfo.channel] || "-" }})
          </span>
        </p>
        <button
          v-if="!signUpSuccess && orderInfo.state === 1"
          @click="jumpPayment"
          class="primary-btn"
        >
          立即支付
        </button>
      </div>
      <p v-if="orderInfo.charge_at" class="charge-at">
        支付时间：{{
          moment(orderInfo.charge_at * 1000).format("YYYY-MM-DD HH:mm:ss")
        }}
      </p>
      <p v-if="orderInfo.remark" class="remark-text charge-at">
        <span>备注：</span>
        <span class="text">{{ orderInfo.remark }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import orderItem from "../mixins/order-item.js";
export default {
  mixins: [orderItem],
};
</script>

<style lang="scss" scoped>
.h5-order-item-wrap {
  width: 9.36rem;
  background: var(--card-bg, #ffffff);
  border-radius: 0.32rem;
  border: 1px solid var(--border-subtle, #efefef);
  margin-bottom: 0.21rem;
  .order-top {
    background: var(--input-bg, #{$saas-bg-color});
    .countdown-wrap {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 0.37rem;
      color: #f03349;
      line-height: 0.53rem;
    }
    .order-status {
      font-weight: 400;
      font-size: 0.37rem;
      color: var(--text-primary, #0d1400);
      line-height: 0.53rem;
    }
    .order-status-success {
      font-weight: 400;
      font-size: 0.37rem;
      color: var(--text-primary, #0d1400);
      line-height: 0.53rem;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.32rem;
    border-bottom: 1px solid var(--border-subtle, #efefef);
    .order-no {
      font-size: 0.37rem;
      color: var(--text-secondary, #515350);
      line-height: 0.53rem;
    }
  }
  .order-list {
    padding: 0 0.32rem;
  }
  .course-item {
    border-bottom: 1px solid var(--border-subtle, #efefef);
    &:last-child {
      border-bottom: none;
    }
  }
  .course-wrap {
    display: flex;
    padding: 0.32rem 0;
    .cover {
      width: 2.81rem;
      height: 1.58rem;
      object-fit: cover;
      margin-right: 0.15rem;
      border-radius: 0.13rem;
    }
    .course-info {
      flex: 1;
      width: 0;
      height: 1.58rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: start;
    }
    .title {
      font-weight: 600;
      font-size: 0.37rem;
      color: var(--text-primary, #0d1400);
      line-height: 0.53rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-break: anywhere;
    }
    .btns-wrap {
      font-weight: 400;
      font-size: 0.37rem;
      color: #00c89d;
      line-height: 0.53rem;
      margin-right: 0.21rem;
    }
  }
  .order-bottom {
    padding: 0.27rem 0.32rem;
    border-top: 1px solid var(--border-subtle, #efefef);
    .charge-at {
      font-size: 0.37rem;
      color: var(--text-secondary, #515350);
      line-height: 0.53rem;
      margin-top: 0.15rem;
    }
    .remark-text {
      display: flex;
      .text {
        flex: 1;
        line-break: anywhere;
      }
    }
    .total-price-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // padding-bottom: 0.21rem;
      button {
        width: 1.88rem;
        height: 0.72rem;
        border-radius: 0.16rem;
        border: 0.03rem solid #00c89d;
        font-weight: 400;
        font-size: 0.37rem;
        color: #00c89d;
        line-height: 0.53rem;
      }
    }
    .total-price {
      font-weight: 600;
      font-size: 0.37rem;
      color: var(--text-primary, #0d1400);
      line-height: 0.53rem;
      span {
        font-weight: 400;
        font-size: 0.37rem;
        color: var(--text-secondary, #515350);
        line-height: 0.53rem;
      }
    }
    .channel {
    }
  }
  .more-btn {
    font-weight: 400;
    font-size: 0.37rem;
    color: #00c89d;
    line-height: 0.53rem;
    display: block;
    padding: 0.15rem 0;
  }
  .operate-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    button {
      width: 1.88rem;
      height: 0.72rem;
      border-radius: 0.16rem;
      border: 0.03rem solid #00c89d;
      font-weight: 400;
      font-size: 0.37rem;
      color: #00c89d;
      line-height: 0.53rem;
      margin-right: 0.27rem;
      margin-bottom: 0.21rem;
    }
    .cancel-btn {
      border: 0.03rem solid var(--border-subtle, #efefef);
      color: var(--text-secondary, #515350);
    }
  }
}
</style>
